// Product lock-up: xenscope two-leaf icon + product name, with an optional subtitle.
import { brand } from "../brand";

// nameSize overrides the product name's font size (default: 55% of the icon height)
export function BrandMark({ size = 40, subtitle, glyphOnly = false, nameSize }: { size?: number; subtitle?: string; glyphOnly?: boolean; nameSize?: number }) {
  return (
    <div className="brandmark">
      <img src={brand.logo.icon} alt={glyphOnly ? brand.productName : ""} style={{ height: size, width: "auto" }} />
      {!glyphOnly && (
        <div>
          <div className="brandmark-name" style={{ fontSize: nameSize ?? Math.round(size * 0.55) }}>
            {brand.productName}
          </div>
          {subtitle && <div className="brandmark-subtitle">{subtitle}</div>}
        </div>
      )}
    </div>
  );
}

// "Powered by [xenscope logo]" credit. Both wordmarks are rendered and CSS shows
// the one that suits the active theme (see .logo-on-light / .logo-on-dark).
export function PoweredBy() {
  return (
    <span className="powered-by">
      Powered by
      <img className="logo-on-light" src={brand.logo.wordmarkDark} alt="xenscope" />
      <img className="logo-on-dark" src={brand.logo.wordmarkLight} alt="xenscope" />
    </span>
  );
}
